import { GET_LocationSection_LIST_Register } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
   LocationSectionList:[]
}

function LocationSectionRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_LocationSection_LIST_Register:
            return {
                ...state,
                    LocationSectionList:action.payload.map(x=>({
                    Id:zeroPad(x.id,8),
                    description:x.description,
                    active:x.active                
                })) 
            }
        default:
           return state
    }  

}

export default LocationSectionRegister;